
riot.tag2('bs-pagination', '  <div class="form-inline pagination">\n    <div class="btn-group" onclick="{prev}">\n      <button class="btn btn-default {disabled: page &lt;= 1}" type="button"><a class="fa fa-angle-left"></a></button>\n    </div><span> стр.</span>\n    <div class="btn-group">\n      <input class="form-control" type="text" style="width: 64px; text-align: right;" value="{parseInt(page)}" onkeyup="{submit}" onchange="{stopPropagation}" onselect="{stopPropagation}">\n    </div><span> из</span><strong> {parseInt(pages)}</strong>\n    <div class="btn-group" onclick="{next}">\n      <button class="btn btn-default {disabled: page &gt;= pages}" type="button"><a class="fa fa-angle-right"></a></button>\n    </div>\n  </div>\n', 'bs-pagination,[riot-tag="bs-pagination"],[data-is="bs-pagination"]{ display: inline-block; position: relative; }', '', function(opts) {
'use strict';

var self = this;

self.page_array = function () {
    var arr = [];
    var current = self.page,
        count = self.pages;

    if (count > 10) {
        var start = current - 5,
            stop = current + 5;

        var dstart = 1 - (current - 5);
        var dstop = count - (current + 5);

        var astop = dstart > 0 ? Math.abs(dstart) : 0;
        var astart = dstop < 0 ? Math.abs(dstop) : 0;

        start = start - astart > 0 ? start - astart : start > 0 ? start : 1;
        stop = stop + astop <= count ? stop + astop : stop <= count ? stop : count;

        for (var i = start; i <= stop; i++) {
            arr.push(i);
        }
    } else {
        for (var i = 0; i < count; i++) {
            arr.push(i + 1);
        }
    }

    return arr;
};

self.first = function (e) {
    if (self.page > 1) {
        self.root.page = self.page = 1;
        $(self.root).trigger('select');
    }
};

self.prev = function (e) {
    if (self.page > 1) {
        self.root.page = --self.page;
        $(self.root).trigger('select');
    }
};

self.next = function (e) {
    if (self.page < self.pages) {
        self.root.page = ++self.page;
        $(self.root).trigger('select');
    }
};

self.last = function (e) {
    if (self.page < self.pages) {
        self.root.page = self.page = self.pages;
        $(self.root).trigger('select');
    }
};

self.select = function (e) {
    self.root.page = self.page = e.item.item;
    $(self.root).trigger('select');
};

self.submit = function (e) {
    if (e.keyCode === 13) {
        var page = parseInt(e.target.value);
        if (typeof page === 'number') {
            if (page > self.pages) page = self.pages;

            if (page < 1) page = 1;

            self.root.page = self.page = page;
            $(self.root).trigger('select');
        }
    }
};

self.stopPropagation = function (e) {
    e.stopPropagation();
    e.stopImmediatePropagation();
};

self.on('update', function () {
    self.pages = parseInt(opts.pages) || 0;
    self.root.page = self.page = parseInt(opts.page) || 1;
});
});


// WEBPACK FOOTER //
// ./components/bs-pagination.tag